<div *ngIf="disabled">
   <span *ngIf='art == 1'>1-malige Bestellung</span><span *ngIf='art == 2'>mehrmalige Bestellung</span><span *ngIf='art == 3'>Direktversand</span>
</div>
<div *ngIf="!disabled">
        <kendo-textbox-container floatingLabel="Auslöser">
                <kendo-dropdownlist [data]="bestellArten" [defaultItem]="{ text: 'Auslöser auswählen', value: 0 }"
        [textField]="'text'" [valueField]="'value'"  [(ngModel)]="art" [valuePrimitive]="true" (valueChange)="valueChanged($event)" >
        </kendo-dropdownlist>
        </kendo-textbox-container>
</div> 